var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.00049C6.27936 6.00415 5.60383 6.03335 5.04873 6.26634C4.2712 6.59269 3.63801 7.19552 3.26811 7.96159C2.96618 8.58687 2.91678 9.38799 2.81796 10.9902L2.66312 13.5009C2.41739 17.4853 2.29452 19.4775 3.46369 20.7387C4.63285 21.9999 6.60253 21.9999 10.5419 21.9999H14.4581C18.3975 21.9999 20.3671 21.9999 21.5363 20.7387C22.7055 19.4775 22.5826 17.4853 22.3369 13.5009L22.182 10.9902C22.0832 9.38799 22.0338 8.58687 21.7319 7.96159C21.362 7.19552 20.7288 6.59269 19.9513 6.26634C19.3962 6.03335 18.7206 6.00415 17.5 6.00049",
    fill: "#2C4A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.00049C6.27936 6.00415 5.60383 6.03335 5.04873 6.26634C4.2712 6.59269 3.63801 7.19552 3.26811 7.96159C2.96618 8.58687 2.91678 9.38799 2.81796 10.9902L2.66312 13.5009C2.41739 17.4853 2.29452 19.4775 3.46369 20.7387C4.63285 21.9999 6.60253 21.9999 10.5419 21.9999H14.4581C18.3975 21.9999 20.3671 21.9999 21.5363 20.7387C22.7055 19.4775 22.5826 17.4853 22.3369 13.5009L22.182 10.9902C22.0832 9.38799 22.0338 8.58687 21.7319 7.96159C21.362 7.19552 20.7288 6.59269 19.9513 6.26634C19.3962 6.03335 18.7206 6.00415 17.5 6.00049",
    stroke: "#30A46C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7L16.6142 4.78543C16.232 3.82996 15.8994 2.7461 14.9166 2.25955C14.3924 2 13.7616 2 12.5 2C11.2384 2 10.6076 2 10.0834 2.25955C9.1006 2.7461 8.76801 3.82996 8.38583 4.78543L7.5 7",
    fill: "#2C4A3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7L16.6142 4.78543C16.232 3.82996 15.8994 2.7461 14.9166 2.25955C14.3924 2 13.7616 2 12.5 2C11.2384 2 10.6076 2 10.0834 2.25955C9.1006 2.7461 8.76801 3.82996 8.38583 4.78543L7.5 7",
    stroke: "#30A46C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14C16 15.933 14.433 17.5 12.5 17.5C10.567 17.5 9 15.933 9 14C9 12.067 10.567 10.5 12.5 10.5C14.433 10.5 16 12.067 16 14Z",
    fill: "#2C4A3A",
    stroke: "#30A46C",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6H12.509",
    stroke: "#34B474",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera01);
export default __webpack_public_path__ + "static/media/camera-01.e30871b19f688693f31b4bfc6374c21b.svg";
export { ForwardRef as ReactComponent };